import {
  FAQ,
  NotFound,
  PillarList,
  Redirect,
  RedirectHandler,
  Single
} from '../pages';

import {
  AirtimeAdvanceLanding,
  AirtimeAdvanceLegal,
  AirtimeAdvanceSummary,
  Home,
  NewsFeed,
  OnboardingLanding,
  OnboardingLegal,
  OnboardingSplash,
  RssContent,
  Search,
  SocialBundle,
  WeatherDetail,
  WhatsNew,
  WhatsNewContent
} from '../journeys';

import {
  FeatureToggles
} from './feature-toggles';

export const WebRoutes = [
  {
    path: '/',
    component: OnboardingSplash
  },
  {
    path: '/landing',
    component: OnboardingLanding
  },
  {
    path: '/landing/legal',
    component: OnboardingLegal
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/pillars/:pillar',
    component: PillarList
  },
  {
    path: '/pillars/:pillar/:pillar_id',
    component: Single
  },
  {
    path: '/page/single/:id',
    component: Single
  },
  {
    path: '/news-content',
    component: RssContent,
    featureToggle: FeatureToggles.EnableFeeds
  },
  {
    path: '/social-bundle',
    component: SocialBundle
  },
  {
    path: '/search',
    component: Search,
    featureToggle: FeatureToggles.EnableSearch
  },
  {
    path: '/whats-new',
    component: WhatsNew
  },
  {
    path: '/whats-new/:content_id',
    component: WhatsNewContent
  },
  {
    path: '/weather',
    component: WeatherDetail,
    featureToggle: FeatureToggles.EnableWeather
  },
  {
    path: '/news-feed',
    component: NewsFeed,
    featureToggle: FeatureToggles.EnableFeeds
  },
  {
    path: '/contact-us',
    component: FAQ
  },
  {
    path: '/advance',
    component: AirtimeAdvanceLanding,
    featureToggle: FeatureToggles.EnableAirtimeAdvance
  },
  {
    path: '/advance/payment',
    component: AirtimeAdvanceSummary,
    featureToggle: FeatureToggles.EnableAirtimeAdvance
  },
  {
    path: '/advance/legal',
    component: AirtimeAdvanceLegal,
    featureToggle: FeatureToggles.EnableAirtimeAdvance
  },
  {
    path: '/advance/:content_id',
    component: Single,
    featureToggle: FeatureToggles.EnableAirtimeAdvance
  },
  {
    path: '/handle-redirect',
    component: RedirectHandler
  },
  {
    path: '/redirect',
    component: Redirect
  },
  {
    component: NotFound
  }
];
